export default "__VITE_ASSET__Bpu$uVOx__"